import { Menu, MenuItem } from '@mui/material';
import { useEffect, useState } from 'react';
import {
  BarChart,
  BoxSeam,
  Chat,
  ClipboardCheck,
  Eye,
  Files,
  Pencil,
  PersonDash,
  PersonPlus,
  Trash,
  CartPlus,
  CurrencyDollar,
  Recycle,
  Person,
  Envelope,
  PiggyBank,
  PiggyBankFill,
  Send,
  Box2,
  Tools,
  ClockHistory,
  MenuButtonWide,
} from 'react-bootstrap-icons';
import { Link } from 'react-router-dom';
import EntityClone from './entityClone';
import EntityArchive from './entityArchive';
import EntityEdit from './entityEdit';
import EntityHistory from './entityHistory';
import EntityMove from './entityMove';
import EntityOwnerChange from './entityOwnerChange';
import EntityStatus from './entityStatus';
import GiveIt from './giveIt';
import { NestedMenuItem } from 'mui-nested-menu';
import { IsRole } from './validator';
import { bake } from './common';
import PutAwayOrder from './putAwayOrder';
import { Api } from './interface';
import EquipmentTypeChange from './equipmentTypeChange';

export default function ActionContext(props) {
  const [giveAction, setGiveAction] = useState(undefined);
  const [isEOL, setIsEOL] = useState(false);
  const [mixedStatus, setMixedStatus] = useState(false);
  const [locationsUsed, setLocationsUsed] = useState(false);

  const eolList = ['Reclaimed', 'Scrapped', 'Shipped', 'Archived'];

  const handleOpen = (modal, type) => {
    setGiveAction(type);
    props.handleActionContextClose(false, modal);
  };

  const closeModal = (refresh) => {
    props.handleActionContextClose(refresh, null);
  };

  const getRequestDisabled = () => {
    if (props.selectedRows.length === 1) {
      return props.currentRow.Available == 0;
    }
    return false;
  };
  const geekDisabled = () => {
    let rows =
      props.selectedRows.length >= 1 ? props.selectedRows : [props.currentRow];
    let type = rows[0]?.Type;
    // all items should be owned by Material Storage
    let ownerCheck = rows.find(
      (row) =>
        !('EntityOwner' in row) || row.EntityOwnerName !== 'Material Storage'
    )
      ? false
      : true;

    //all items need to be in geek+ location
    let locationCheck = rows.find(
      (row) =>
        !row.Location || !row.Location.join().trim().includes('Geek+ Storage')
    )
      ? false
      : true;
    let field =
      type === 'SSD'
        ? ['Serial Number', 'Build ID']
        : type === 'Component'
          ? ['Component Lot ID', 'Quantity']
          : null;
    // for SSDs BuildID and Serial Number are required
    //for components Component Name and Quantity are required
    let validFieldCheck = rows.find(
      (row) =>
        field.some((val) => Object.keys(row).indexOf(val) === -1) ||
        (props.matType === 'Component' &&
          (row['Component Name']?.[0] !== rows[0]['Component Name'] ||
            row['Quantity'] < 1))
    )
      ? false
      : true;

    //all units should be In Inventory
    let statusCheck = rows.find(
      (row) => !('EntityStatus' in row) || row.EntityStatus !== 'In Inventory'
    )
      ? false
      : true;
    return !(ownerCheck && locationCheck && validFieldCheck && statusCheck);
  };

  const ptoDisabled = () => {
    // Material coming to material Storage via bulk upload (In Transit SSDs) and material already residing at MS

    let rows =
      props.selectedRows.length >= 1 ? props.selectedRows : [props.currentRow];
    let foundPTO = rows.find((row) => {
      // capture the last part of the location
      let rowLocation = row['Path'].split('>');
      rowLocation = rowLocation[rowLocation.length - 1]?.trim();

      return (
        (row['Geek PTO ID'] && row['Geek PTO ID'][0] !== undefined) ||
        // verify if a drive is already in Geek+ Storage or not
        rowLocation === 'Geek+ Storage'
      );
    }); // Already at Geek or In-transit towards geekstorage

    if (foundPTO) {
      return true;
    } else {
      let found = rows.find(
        (row) =>
          row.EntityOwnerName !== 'Material Storage' &&
          row.EntityStatus !== 'In Transit'
      ); // neither owned by material storage nor intransit towards material storage

      if (found) {
        return true;
      } else {
        return false;
      }
    }
  };
  const giveDisabled = () => {
    let rows =
      props.selectedRows.length >= 1 ? props.selectedRows : [props.currentRow];
    let owner = rows[0]?.EntityOwner;
    // location array is always there
    // location needs to be same only till Site to be eligible for give it
    // i.e., Geo -> Site, e.g., AMR -> Folsom
    let location = rows[0]?.Location.slice(0, 2).join().trim();
    let type = rows[0]?.Type;
    let componentName = rows[0]['Component Name']
      ? rows[0]['Component Name'][0]
      : null;

    let field =
      type === 'SSD'
        ? ['Serial Number']
        : type === 'Component'
          ? ['Component Lot ID', 'Quantity']
          : null;

    if (owner && location) {
      let found = rows.find(
        (row) =>
          !('EntityOwner' in row) ||
          row.EntityOwner !== owner ||
          !('EntityStatus' in row) ||
          row.EntityStatus !== 'In Inventory' ||
          field.some((val) => Object.keys(row).indexOf(val) === -1) ||
          (props.matType === 'Component' &&
            (row['Component Name']?.[0] !== componentName ||
              row['Quantity'] < 1)) ||
          !row.Location ||
          row.Location.slice(0, 2).join().trim() !== location ||
          row['Borrower']
      );

      // Only allow Material Storage to do Give It from Material Storage
      let classStoreCheck =
        props.isClassStoreMember === false &&
        rows.some((row) => {
          return row.EntityOwnerName === 'Material Storage';
        });

      if (found || classStoreCheck) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  };

  const archiveDisabled = () => {
    let rows =
      props.selectedRows.length >= 1 ? props.selectedRows : [props.currentRow];
    // disable if already archived, i.e., Status is "Archived"
    if (props.level === 'Material') {
      if (IsRole(['Admin', 'Material Manager'])) {
        let found = rows.find(
          (row) => !('EntityStatus' in row) || row.EntityStatus === 'Archived'
        );
        return found;
      } else {
        let user = bake({ key: 'user' });
        let found = rows.find(
          (row) =>
            !('EntityOwnerName' in row) ||
            row.EntityOwnerName !== user.name ||
            !('EntityStatus' in row) ||
            row.EntityStatus === 'Archived'
        );

        return found;
      }
    } else if (props.level === '') {
      // Equipment

      if (IsRole(['Admin', 'Equipment Manager'])) {
        let found = rows.find(
          (row) => !('EntityStatus' in row) || row.EntityStatus === 'Archived'
        );
        return found;
      } else {
        let user = bake({ key: 'user' });
        let found = rows.find(
          (row) =>
            !('EntityOwnerName' in row) ||
            row.EntityOwnerName !== user.name ||
            !('EntityStatus' in row) ||
            row.EntityStatus === 'Archived'
        );
        return found;
      }
    } else if (['Lab', 'Location'].includes(props.level)) {
      // Labs or Locations
      let found = rows.find(
        (row) => !('EntityStatus' in row) || row.EntityStatus === 'Archived'
      );
      if (found) {
        return true;
      }
      let canEdit =
        props.level === 'Location'
          ? IsRole(['Admin', 'Equipment Manager'])
          : IsRole([
              'Admin',
              'Material Manager',
              'Planner',
              'Material Storage',
            ]);

      if (canEdit) {
        Api({ sp: 'getLocationCount', json: { rows: rows } }).then(
          (response) => {
            let found = response.filter((row) => row['AssetsInLocation'] > 0);
            if (found) {
              setLocationsUsed(true);
            }
          }
        );
      } else {
        let user = bake({ key: 'user' });
        let found = rows.find(
          (row) =>
            !('EntityOwnerName' in row) ||
            row.EntityOwnerName !== user.name ||
            !('EntityStatus' in row) ||
            row.EntityStatus === 'Archived'
        );
        return found;
      }
    } else {
      return true;
    }
  };

  const loanEnabled = () => {
    let rows =
      props.selectedRows.length >= 1 ? props.selectedRows : [props.currentRow];
    let owner = rows[0]?.EntityOwner;
    let location = rows[0]?.Location.slice(0, 2).join().trim();

    if (owner && location) {
      let found = rows.find(
        (row) =>
          !('EntityOwner' in row) ||
          row.EntityOwner !== owner ||
          !('EntityStatus' in row) ||
          row.EntityStatus !== 'In Inventory' ||
          !row.Location ||
          row.Location.slice(0, 2).join().trim() !== location ||
          !row['Borrower']
      );
      if (found) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  };

  const loanExtendEnabled = () => {
    // user should be either Material Manager or Admin, or owner of the item, or borrower of the item to be able to extend loan
    let rows =
      props.selectedRows.length >= 1 ? props.selectedRows : [props.currentRow];
    let user = bake({ key: 'user' });

    // When multiple rows are selected, they must share the same borrower and loan due date
    if (rows.length > 1) {
      const firstBorrower = rows[0]?.Borrower;
      const firstDueDate = rows[0]?.['Loan Due Date'];

      if (!firstBorrower || !firstDueDate) {
        return false;
      }
      const allMatch = rows.every((row) => {
        const rowDueDate = row?.['Loan Due Date'] ?? null;
        return row?.Borrower === firstBorrower && rowDueDate === firstDueDate;
      });
      if (!allMatch) {
        return false;
      }
    }

    if (IsRole(['Admin', 'Material Manager'])) {
      return true;
    }

    return rows.every(
      (row) =>
        'Borrower' in row &&
        (row.Borrower === user.name || row.EntityOwnerName === user.name)
    );
  };

  const changeTypeEnabled = () => {
    return (
      !props.grouped &&
      !props.level &&
      !props.archiveMode &&
      (props.selectedRows.length === 0 ||
        (props.selectedRows.length === 1 &&
          props.currentRow?.Entity_DBID === props.selectedRows[0].Entity_DBID))
    );
  };

  /**
   * Checks if the current user owns all rows.
   *
   * @param {Array} rows - An Array of row objects to check ownership for.
   * @returns {boolean} - Returns true if the current user owns all rows, false otherwise.
   */
  const currentUserOwnsAllRows = (rows) => {
    return rows.every((row) => currentUserOwnsRow(row));
  };

  /**
   * Checks if the current user owns the specified row.
   *
   * @param {Object} row - The row object to check ownership for.
   * @returns {boolean} - Returns true if the current user owns the row, false otherwise.
   */
  const currentUserOwnsRow = (row) => {
    let user = bake({ key: 'user' });
    let entityOwnerName = row.EntityOwnerName;

    return entityOwnerName === user.name;
  };

  /**
   * Checks if the current user is the owner of the selected rows or the current row, or if they have the appropriate role.
   *
   * @returns {boolean}
   */
  const currentUserIsOwner = () => {
    // Admins and Equipment Managers can always access
    let roleCheck = IsRole(['Admin', 'Equipment Manager']);
    if (roleCheck) {
      return true;
    }

    return props.selectedRows.length > 0
      ? currentUserOwnsAllRows(props.selectedRows)
      : currentUserOwnsRow(props.currentRow);
  };
  // checks to enable ISO related actions
  const isoEnabled = () => {
    return (
      !props.grouped &&
      !props.level &&
      !props.archiveMode &&
      (props.selectedRows.length === 0 ||
        (props.selectedRows.length === 1 &&
          props.currentRow?.Entity_DBID === props.selectedRows[0].Entity_DBID))
    );
  };

  useEffect(() => {
    if (!props.grouped && props.currentRow.EntityStatus) {
      let eol = props.selectedRows.length
        ? props.selectedRows.some((x) => eolList.includes(x.EntityStatus))
        : eolList.includes(props.currentRow.EntityStatus);
      setIsEOL(eol);
    }

    if (
      props.selectedRows.length >= 1 &&
      props.selectedRows[0].EntityStatus &&
      !props.selectedRows.every(
        (x) =>
          x.EntityStatus &&
          x.EntityStatus === props.selectedRows[0].EntityStatus
      )
    ) {
      setMixedStatus(true);
    }
  }, []);

  // handle Perform Service action
  const handlePerformService = (refresh) => {
    let modal = 'EquipmentService';
    props.handlePerformService();
    props.handleActionContextClose(refresh, modal);
  };

  // handle Service History action
  const openServiceHistory = (refresh) => {
    let modal = 'EquipmentServiceHistory';
    props.openServiceHistory();
    props.handleActionContextClose(refresh, modal);
  };

  const gotDisabled = () => {
    let rows =
      props.selectedRows.length >= 1 ? props.selectedRows : [props.currentRow];
    let owner = rows[0]?.EntityOwner;
    let componentName = rows[0]['Component Name']
      ? rows[0]['Component Name'][0]
      : null;
    if (owner) {
      let found = rows.find(
        (row) =>
          row?.EntityOwner !== owner ||
          (props.matType === 'Component' &&
            (row['Component Name']?.[0] !== componentName ||
              row['Quantity'] < 1 ||
              rows?.length > 1)) ||
          row['Borrower']
      );
      if (found) {
        return true;
      } else {
        return false;
      }
    } else return true;
  };

  return (
    <div>
      {props.contextAnchor !== null ? (
        <Menu
          id="basic-menu"
          anchorEl={props.contextAnchor}
          open={props.contextAnchor !== null}
          onClose={() => closeModal()}
          MenuListProps={{
            'aria-labelledby': 'basic-button',
          }}
        >
          {!props.grouped &&
          !props.archiveMode &&
          !['Material'].includes(props.level) &&
          IsRole(['Equipment Manager', 'Material Storage', 'Admin']) ? (
            <MenuItem
              onClick={() => handleOpen('EntityStatus')}
              disabled={mixedStatus}
            >
              <ClipboardCheck
                className="context-icon"
                data-modal={'EntityStatus'}
                onClick={handleOpen}
              />
              {props.selectedRows.length > 0 ? 'Selected Status' : 'Status'}
            </MenuItem>
          ) : null}
          {!props.grouped && !props.archiveMode ? (
            !props.selectedRows.length > 0 ? (
              <MenuItem onClick={() => handleOpen('EntityEdit')}>
                {props.canEdit || currentUserIsOwner() ? (
                  <>
                    <Pencil className="context-icon" /> Edit
                  </>
                ) : (
                  <>
                    <Eye className="context-icon" /> Details
                  </>
                )}
              </MenuItem>
            ) : props.canEdit || currentUserIsOwner() ? (
              <MenuItem
                onClick={() => handleOpen('EntityEdit')}
                disabled={isEOL}
              >
                <>
                  <Pencil className="context-icon" /> Edit Selected
                </>
              </MenuItem>
            ) : null
          ) : null}
          {(props.selectedRows.length === 0 ||
            (props.selectedRows.length === 1 &&
              props.currentRow?.Entity_DBID ===
                props.selectedRows[0].Entity_DBID)) &&
          !props.myHomePage &&
          !props.grouped ? (
            <MenuItem onClick={() => handleOpen('Dashboard')}>
              <Link
                className="menu-link"
                to={'/dash?id=' + props.currentRow?.Entity_DBID}
              >
                <BarChart className="context-icon" /> Dashboard
              </Link>
            </MenuItem>
          ) : null}
          {/* Show when:
             - NOT in grouped view
             - NOT in archive mode
             - Level is empty (equipment level, not material/lab/location)
             - Either no rows selected OR current row exists
             - Current user is owner or Equipment Manager*/}
          {changeTypeEnabled() && currentUserIsOwner() ? (
            <MenuItem onClick={() => handleOpen('ChangeType')}>
              {props.canEdit || currentUserIsOwner() ? (
                <>
                  <MenuButtonWide className="context-icon" /> Change Type
                </>
              ) : null}
            </MenuItem>
          ) : null}
          {!props.grouped &&
          !(props.level === 'Geo') &&
          props.level !== 'Material' &&
          !props.archiveMode &&
          currentUserIsOwner() ? (
            <MenuItem
              onClick={() => handleOpen('EntityMove')}
              disabled={!currentUserIsOwner() || isEOL}
            >
              <BoxSeam className="context-icon" />{' '}
              {props.selectedRows.length > 0 ? 'Move Selected' : 'Move'}
            </MenuItem>
          ) : null}
          {!props.grouped &&
          !props.level &&
          !props.archiveMode &&
          currentUserIsOwner() ? (
            <MenuItem
              onClick={() => handleOpen('EntityOwnerChange')}
              disabled={!currentUserIsOwner() || isEOL}
            >
              <Person className="context-icon" /> {'Change Owner'}
            </MenuItem>
          ) : null}
          {isoEnabled() && currentUserIsOwner() ? (
            <MenuItem
              onClick={() => handlePerformService()}
              disabled={!currentUserIsOwner() || isEOL}
            >
              <Tools className="context-icon" /> {'Perform Service'}
            </MenuItem>
          ) : null}
          {isoEnabled() && currentUserIsOwner() ? (
            <MenuItem
              onClick={() => openServiceHistory()}
              disabled={!currentUserIsOwner() || isEOL}
            >
              <ClockHistory className="context-icon" /> {'Service History'}
            </MenuItem>
          ) : null}
          {(props.selectedRows.length === 0 ||
            (props.selectedRows.length === 1 &&
              props.currentRow?.Entity_DBID ===
                props.selectedRows[0].Entity_DBID)) &&
          !props.grouped &&
          !props.archiveMode &&
          props.level !== 'Material' ? (
            <MenuItem
              onClick={() => handleOpen('EntityClone')}
              disabled={!props.canEdit || isEOL}
            >
              <Files className="context-icon" /> Clone
            </MenuItem>
          ) : null}
          {/* Nested Give It */}
          {props.level === 'Material' &&
          !props.grouped &&
          !props.archiveMode ? (
            <NestedMenuItem
              leftIcon={<PersonDash />}
              className="nested-menu-item give-it"
              label={
                props.selectedRows.length > 1 ? 'Give Selected' : 'Give It'
              }
              parentMenuOpen={
                props.contextAnchor !== null && !isEOL && !giveDisabled()
              }
              disabled={giveDisabled() || isEOL}
            >
              <MenuItem
                onClick={() => handleOpen('GiveIt', 'Give')}
                disabled={giveDisabled() || isEOL}
              >
                <Person className="context-icon" /> Internal
              </MenuItem>
              <MenuItem
                onClick={() => handleOpen('GiveIt', 'Ship')}
                disabled={giveDisabled() || isEOL}
              >
                <Envelope className="context-icon" /> External
              </MenuItem>
              {props.isClassStoreMember && !geekDisabled() ? (
                <MenuItem
                  onClick={() => handleOpen('GiveIt', 'GeekPickup')}
                  disabled={geekDisabled() || isEOL}
                >
                  <Send className="context-icon" /> Pickup From Geek+
                </MenuItem>
              ) : null}
              <MenuItem
                onClick={() => handleOpen('GiveIt', 'Loan')}
                disabled={giveDisabled() || isEOL}
              >
                <PiggyBank className="context-icon" /> Loan
              </MenuItem>
              <MenuItem
                onClick={() => handleOpen('GiveIt', 'Reclaim')}
                disabled={giveDisabled() || isEOL}
              >
                <CurrencyDollar className="context-icon" /> Reclaim
              </MenuItem>
              <MenuItem
                onClick={() => handleOpen('GiveIt', 'Scrap')}
                disabled={giveDisabled() || isEOL}
              >
                <Recycle className="context-icon" /> Scrap
              </MenuItem>
            </NestedMenuItem>
          ) : null}
          {props.level === 'Material' &&
          !props.grouped &&
          !props.archiveMode ? (
            <MenuItem
              onClick={() => handleOpen('GiveIt', 'Got')}
              disabled={gotDisabled() || isEOL}
            >
              <PersonPlus className="context-icon" /> Got{' '}
              {props.selectedRows.length > 1 ? 'Selected' : 'It'}
            </MenuItem>
          ) : null}
          {IsRole(['Admin', 'Material Manager']) &&
          props.level === 'Material' &&
          !props.grouped &&
          !props.archiveMode &&
          !ptoDisabled() ? (
            <MenuItem
              onClick={() => handleOpen('PTO')}
              disabled={ptoDisabled() || isEOL}
            >
              <Box2 className="context-icon" /> Create PTO
            </MenuItem>
          ) : null}
          {props.level === 'Material' && !props.grouped && loanEnabled() ? (
            <MenuItem onClick={() => handleOpen('GiveIt', 'Return Loan')}>
              <PiggyBank className="context-icon" /> Return Loan
            </MenuItem>
          ) : null}
          {props.level === 'Material' &&
          !props.grouped &&
          loanEnabled() &&
          loanExtendEnabled() ? (
            <MenuItem onClick={() => handleOpen('GiveIt', 'Extend Loan')}>
              <PiggyBankFill className="context-icon" /> Extend Loan
            </MenuItem>
          ) : null}
          {props.level === 'Material' && props.grouped ? (
            <MenuItem
              onClick={() => handleOpen('RequestCreate')}
              disabled={getRequestDisabled()}
            >
              <CartPlus className="context-icon" /> Add to Request
            </MenuItem>
          ) : null}
          {(props.selectedRows.length === 0 ||
            (props.selectedRows.length === 1 &&
              props.currentRow?.Entity_DBID ===
                props.selectedRows[0].Entity_DBID)) &&
          !props.grouped ? (
            <MenuItem onClick={() => handleOpen('EntityHistory')}>
              <Chat className="context-icon" /> History
            </MenuItem>
          ) : null}
          {/* do not delete epo(s) */}
          {!props.grouped && !props.archiveMode ? (
            <MenuItem
              onClick={() => handleOpen('EntityArchive')}
              disabled={archiveDisabled()}
            >
              <Trash color="red" className="context-icon" />{' '}
              {props.selectedRows.length > 0 ? 'Archive Selected' : 'Archive'}
            </MenuItem>
          ) : null}
        </Menu>
      ) : null}

      {props.currentModal === 'EntityClone' ? (
        <EntityClone
          level={props.level}
          item={props.currentRow}
          closeModal={props.closeModal}
          open={props.currentModal === 'EntityClone'}
          close={closeModal}
        ></EntityClone>
      ) : null}

      {props.currentModal === 'EntityArchive' ? (
        <EntityArchive
          level={props.level}
          matType={props.matType}
          open={props.currentModal === 'EntityArchive'}
          items={
            props.selectedRows.length > 0
              ? props.selectedRows
              : [props.currentRow]
          }
          closeModal={props.closeModal}
          close={closeModal}
          locationsUsed={locationsUsed}
        ></EntityArchive>
      ) : null}

      {props.currentModal === 'EntityHistory' ? (
        <EntityHistory
          level={props.level}
          item={props.currentRow}
          open={props.currentModal === 'EntityHistory'}
          close={closeModal}
          archiveMode={props.archiveMode}
        ></EntityHistory>
      ) : null}
      {props.currentModal === 'EntityStatus' ? (
        <EntityStatus
          level={props.level}
          items={
            props.selectedRows.length > 0
              ? props.selectedRows
              : [props.currentRow]
          }
          open={props.currentModal === 'EntityStatus'}
          close={closeModal}
        ></EntityStatus>
      ) : null}
      {props.currentModal === 'EntityMove' ? (
        <EntityMove
          level={props.level}
          items={
            props.selectedRows.length > 0
              ? props.selectedRows
              : [props.currentRow]
          }
          open={props.currentModal === 'EntityMove'}
          close={closeModal}
        ></EntityMove>
      ) : null}
      {props.currentModal === 'EntityOwnerChange' ? (
        <EntityOwnerChange
          level={props.level}
          items={
            props.selectedRows.length > 0
              ? props.selectedRows
              : [props.currentRow]
          }
          open={props.currentModal === 'EntityOwnerChange'}
          close={closeModal}
        ></EntityOwnerChange>
      ) : null}
      {props.currentRow && props.currentModal === 'EntityEdit' ? (
        <EntityEdit
          level={props.level}
          items={
            props.selectedRows.length > 0
              ? props.selectedRows
              : [props.currentRow]
          }
          open={props.currentModal === 'EntityEdit'}
          canEdit={props.canEdit || currentUserIsOwner()}
          close={closeModal}
          handlePerformService={(refresh) => handlePerformService(refresh)}
          openServiceHistory={(refresh) => openServiceHistory(refresh)}
        ></EntityEdit>
      ) : null}
      {props.currentRow && props.currentModal === 'ChangeType' ? (
        <EquipmentTypeChange
          level={props.level}
          items={
            props.selectedRows.length > 0
              ? props.selectedRows
              : [props.currentRow]
          }
          open={props.currentModal === 'ChangeType'}
          canEdit={props.canEdit || currentUserIsOwner()}
          close={closeModal}
        ></EquipmentTypeChange>
      ) : null}
      {props.currentModal === 'GiveIt' ? (
        <GiveIt
          show={props.currentModal === 'GiveIt'}
          close={(refresh) => closeModal(refresh)}
          list={
            props.selectedRows.length > 0
              ? props.selectedRows
              : [props.currentRow]
          }
          type={giveAction}
          matType={props.matType}
          isClassStoreMember={props.isClassStoreMember}
        ></GiveIt>
      ) : null}
      {props.currentModal === 'PTO' ? (
        <PutAwayOrder
          title="Give"
          show={props.currentModal === 'PTO'}
          close={(refresh) => closeModal(refresh)}
          list={
            props.selectedRows.length > 0
              ? props.selectedRows
              : [props.currentRow]
          }
        ></PutAwayOrder>
      ) : null}
    </div>
  );
}
